<template>
  <v-container>
    <v-form
    ref="editUserForm"
    lazy-validation>
      <v-row justify="space-around">
        <v-col cols="12" md="5">
            Korisničko ime: {{ user.username}}
        </v-col>
        <v-col cols="12" md="5">
            Status: {{ activeUser(user.active) }}
        </v-col>
        </v-row>
      <v-row>
            <v-divider class="mt-5"></v-divider>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="12" md="5">
                <v-text-field
                v-model.trim="user.name"
                label="Ime">
                </v-text-field>
                <v-text-field
                v-model.trim="user.lastname"
                label="Prezime">
                </v-text-field>
                <v-text-field
                v-model.trim="user.username"
                label="Korisničko ime"
                readonly>
                </v-text-field>
                <v-text-field
                :rules="[v => !!v || '!', v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email adresa nije validna']"
                v-model.trim="user.email"
                label="Email">
                </v-text-field>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="save">
                Sačuvaj
                </v-btn>
                <v-btn 
                class="mx-2"
                :dark="hasChanged"
                :disabled="!hasChanged"
                color="#2b5d66"
                @click="cancel">
                Otkaži
                </v-btn>
            </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>
<script>
    export default {
        name: "EditUser",
        data() {
            return {
                initialUser: {
                    userId: -1,
                    username: "",
                    name: "",
                    lastname: "",
                    email: ""
                },
                user: {
                    userId: -1,
                    username: "",
                    name: "",
                    lastname: "",
                    email: ""
                }
            }
        },
        mounted() {
            this.getUserInformation();
        },
        computed: {
            hasChanged () {
                return JSON.stringify(this.user) !== JSON.stringify(this.initialUser)
            }
        },
        methods: {
            getUserInformation() {
                this.axios.get('User/UserDetails?userId=' + this.$route.query.id).then((response) => {
                    this.initialUser = response.data;
                    this.user = JSON.parse(JSON.stringify(this.initialUser));
                })
                .catch(err => console.log(err));
            },
            validation() {
                return this.$refs.editUserForm.validate();
            },
            save() {
                if(this.validation()) {
                    this.axios.post('User/Save', this.user)
                    .then(response => {
                        if(response.data.message.length == 0) {
                            this.initialUser = response.data;
                            this.user = JSON.parse(JSON.stringify(this.initialUser));
                            this.$root.displayNotificationMsg('Sačuvano', 'success')
                        }
                        else {
                            this.user = JSON.parse(JSON.stringify(this.initialUser));
                            this.$root.displayNotificationMsg(response.data.message, 'warning')
                        }
                        
                    })
                    .catch(err => console.log(err));
                }
                else {
                    this.$root.displayNotificationMsg('Morate popuniti sva obavezna polja', 'warning')
                }
                
            },
            cancel() {
                this.user = JSON.parse(JSON.stringify(this.initialUser))
            },
            activeUser(active) {
                if(active)
                    return "Aktivan";
                else
                    return "Deaktiviran";
            },
        }
    }
</script>